import React from 'react';
import { portfolioData } from '../../data/portfolioData';
import './Footer.css';

const Footer = () => {
  const { personalInfo } = portfolioData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>{personalInfo.name}</h3>
            <p>Software Developer specializing in full-stack development with expertise in Flutter, Spring Boot, and cloud technologies.</p>
            <div className="footer-social">
              <a href={personalInfo.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href={personalInfo.github} target="_blank" rel="noopener noreferrer" aria-label="GitHub">
                <i className="fab fa-github"></i>
              </a>
              <a href={`mailto:${personalInfo.email}`} aria-label="Email">
                <i className="fas fa-envelope"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#experience">Experience</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#education">Education</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-contact">
            <h4>Contact Info</h4>
            <p>
              <i className="fas fa-map-marker-alt"></i>
              <span>{personalInfo.location}</span>
            </p>
            <p>
              <i className="fas fa-phone"></i>
              <span>{personalInfo.phone}</span>
            </p>
            <p>
              <i className="fas fa-envelope"></i>
              <span>{personalInfo.email}</span>
            </p>
            <p>
              <i className="fas fa-id-card"></i>
              <span>Driver's License: {personalInfo.driversLicense}</span>
            </p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} {personalInfo.name}. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;